import React from "react";
import Discount from "../discount";
import { usePromotionsContext } from "../../hooks/usePromotionsContext";
import { RootState } from "../../state/store";
import { useSelector } from "react-redux";
import PromoCodeWidget from "../promoCodeWidget";

const PromoCodesContainer = () => {
  const { availablePromoCodes } = usePromotionsContext();
  const { has_promotions: hasValidPromotions } = useSelector((state: RootState) => state.company);
  const { id: userId } = useSelector((state: RootState) => state.user);

  return (
    <>
      {hasValidPromotions && availablePromoCodes.length ? (
        userId ? (
          <PromoCodeWidget />
        ) : null
      ) : (
        <Discount />
      )}
    </>
  );
};

export default PromoCodesContainer;
